import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0324 from "../lesson-24/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "316ebc31-9a83-4dfd-92ae-0b57d2f66412",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0324),
    lesson: lesson0324,
  },
];

export default lessonLinks;
